<script>
	import { page } from '$app/stores';
	import { _, locale } from 'svelte-i18n';
	import '$lib/style/app.css';
	import { settings, createLocaleSettings } from 'svelte-ux';

	import Debug from '$components/shared/Debug.svelte';

	/** @type {import('./$types').LayoutData} */
	export let data;

	$: locale.set($page.data.lang);

	settings({
		themes: {
			light: ['light'],
			dark: ['light']
		},

		components: {
			Backdrop: {
				classes: '!bg-black/50 backdrop-blur-[2px]'
			},
			Button: {
				classes: 'tracking-normal !gap-2'
			},
			TextField: {
				classes: {
					container: 'rounded-md border !border-gray-border shadow-radio transition-all',
					input: 'text-space-black p-1 font-medium 0',
					label: 'text-space-black font-semibold transition-all',
					error: 'text-error-red font-semibold ml-0 mt-1 transition-all'
				}
			},
			Field: {
				classes: {
					container: 'rounded-md border !border-gray-border shadow-radio transition-all',
					input: 'text-space-black p-1 font-medium 0',
					label: 'text-space-black font-semibold transition-all',
					error: 'text-error-red font-semibold ml-0 mt-1 transition-all'
				}
			},
			Switch: {
				classes: {
					switch:
						'border-0 data-[checked=false]:bg-gray-border data-[checked=true]:bg-sky-blue transition-all w-11',
					toggle: 'bg-white drop-shadow w-fit	'
				}
			},
			ToggleGroup: {
				classes: {
					root: 'bg-white',
					options: 'bg-white rounded-lg border border-gray-border p-1'
				}
			},
			ToggleOption: {
				classes: {
					root: 'text-sm [&.selected]:text-white hover:text-dark-gray text-dark-gray hover:bg-area-light rounded-md',
					indicator: 'btn-sm btn-primary ',
					option: 'font-semibold !px-5 !py-2'
				}
			},
			Radio: {
				classes: {
					root: 'text-sm [&.selected]:text-white'
				}
			},
			Checkbox: {
				classes: {
					checkbox: 'border',
					icon: 'text-white'
				}
			},
			DateField: {
				classes: {
					field: {
						input: 'font-sans'
					}
				}
			},
			CopyButton: { classes: 'text-sky-blue hover:text-sky-blue-hover' }
		},

		localeFormats: {
			si: createLocaleSettings({
				locale: 'si',

				formats: {
					dates: {
						baseParsing: 'dd.MM.yyyy',
						ordinalSuffixes: {}
					},

					numbers: {
						defaults: {
							currency: 'EUR'
						}
					}
				},

				dictionary: {
					Ok: 'Potrdi',
					Cancel: 'Prekliči',

					Date: {
						Start: 'Začetek',
						End: 'Konec',

						Day: 'Dan',
						DayTime: 'Dan & Ura',
						Time: 'Ura',
						Week: 'Teden',
						Month: 'Mesec',
						Quarter: 'Četrtletje',
						CalendarYear: 'Leto',
						FiscalYearOct: 'Fiskalno leto (oktober)',
						BiWeek: 'Dvakrat na teden',

						PeriodDay: {
							Current: 'Danes',
							Last: 'Včeraj',
							LastX: 'Zadnjih {0} dni'
						}
					}
				}
			})
		}
	});
</script>

<Debug {data} />
<div>
	<slot />
</div>
